export enum ErrorSeverity {
    Error = "Error",
    Warning = "Warning",
    Success = "Success",
    Unknown = "Unknown",
}
